module.exports = __webpack_public_path__ + "media/images/clients/home-3966e6672949a1c772e5f681e529f9eb.svg";